import * as React from 'react';
import { Box, Typography, useLocaleContext, SkipTrackingProvider } from '@drone-js/core';
import { range, getDateFnsLocaleOrDefault } from '../DatePicker/util/index.js';
import { enUS } from 'date-fns/locale';

var DAYS_PER_WEEK = 7;
var getDayFragment = function getDayFragment(day) {
  return /*#__PURE__*/React.createElement(Box, {
    key: day,
    minWidth: "28px",
    minHeight: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexGrow: 1,
    m: "8"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body-default-strong",
    textColor: "base.default"
  }, day));
};
var getDaysOfWeek = function getDaysOfWeek(locale) {
  var _locale$options$weekS, _locale$options;
  var weekStartsOn = (_locale$options$weekS = (_locale$options = locale.options) === null || _locale$options === void 0 ? void 0 : _locale$options.weekStartsOn) !== null && _locale$options$weekS !== void 0 ? _locale$options$weekS : 0;
  return range(0, DAYS_PER_WEEK).map(function (day) {
    return (day + weekStartsOn) % DAYS_PER_WEEK;
  }).map(function (day) {
    var _locale$localize$day, _locale$localize;
    return (_locale$localize$day = (_locale$localize = locale.localize) === null || _locale$localize === void 0 ? void 0 : _locale$localize.day(day, {
      width: 'short'
    })) !== null && _locale$localize$day !== void 0 ? _locale$localize$day : '';
  });
};
var WeekDisplay = function WeekDisplay() {
  var _useLocaleContext = useLocaleContext(),
    locale = _useLocaleContext.locale;
  var dateFnsLocale = getDateFnsLocaleOrDefault(locale, enUS);
  return /*#__PURE__*/React.createElement(SkipTrackingProvider, null, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    backgroundColor: "base.background"
  }, getDaysOfWeek(dateFnsLocale).map(getDayFragment)));
};
WeekDisplay.displayName = 'WeekDisplay';

export { WeekDisplay };
//# sourceMappingURL=WeekDisplay.js.map
